$('.bookings-section--warning').on('click', '[data-js-dismiss]', function(e) {
  $(e.delegateTarget).hide()
})
